export const INSTALLATION_STATUS = {
  WAITING_APPROVAL: 'Aguardando aprovação',
  REJECTED: 'Rejeitada',
  IN_ANALYSIS: 'Em análise',
  REFUSED: 'Recusada',
  WAITING_CONNECTION: 'Aguardando conexão',
  CONNECTING: 'Em Conexão',
  ACTIVE: 'Ativa',
  INACTIVATION_REQUESTED: 'Inativação solicitada',
  DISCONNECTED: 'Desconectada',
  INACTIVE: 'Inativa',
  PENDING_INFORMATION: 'Informações Pendentes',
  DEBT: 'Divida',
  SETTLEMENT: 'Acordo',
  LOW_QUALITY_IMAGE: 'Imagem ruim',
  WRONG_ADDRESS: 'Endereço incorreto',
  WRONG_OWNER: 'Titular incorreto',
  CHANGING_PARTNER: 'Troca de titular',
  WRONG_CREDENTIALS: 'Login incorreto',
  DUPLICITY: 'Duplicidade',
  ENERGY_REPORT: 'Relatório Energia',
}

export const INSTALLATION_STATUS_IN_PTBR = {
  'WAITING_CONNECTION': 'Aguardando conexão',
  'CONNECTING': 'Em conexão',
  'ACTIVE': 'Ativa',
  'INACTIVATION_REQUESTED': 'Inativação solicitada',
  'DISCONNECTED': 'Desconectada',
  'DEBT': 'Divida',
  'INACTIVE': 'Inativo',
  'SETTLEMENT': 'Acordo',
  'WRONG_OWNER': 'Titular incorreto',
  'DUPLICITY': 'Duplicidade',
  'ENERGY_REPORT': 'Relatório Energia',
}
